import {Disclaimers} from '@cliotech-web/disclaimers';


export default () => {

    (function( dataLayer){

      let broker = window._broker;
      let profile = {[broker]:languageAttributes.footerDisclaimer};
      let footer_elem = document.querySelector(".footer-shared");

       new Disclaimers(profile, broker, footer_elem);
        
    })(window.dataLayer || []);

};
